

export function formatBEP20Token(_balance: string) {
    return (+_balance / 1_000_000_000_000_000_000).toString();
}